export default "__VITE_ASSET__a6c67bcf__"